import { ObjectType, Field, InputType, Int, ID, registerEnumType } from 'type-graphql'

import { Board } from './board.js'
import { BoardHistory } from './board-history.js'

@InputType({ description: 'Input for creating a new board.' })
export class NewBoard {
  @Field({ description: 'The name of the new board.' })
  name: string

  @Field({ nullable: true, description: 'A detailed description for the new board.' })
  description?: string

  @Field({ description: 'The JSON model for the new board.' })
  model: string

  @Field({ nullable: true, description: "The type for the new board, can be 'main', 'sub', or 'popup'." })
  type?: 'main' | 'sub' | 'popup'

  @Field({ nullable: true, description: 'The ID of the group to associate the new board with.' })
  groupId?: string

  @Field({ nullable: true, description: 'A base64 encoded thumbnail image for the new board.' })
  thumbnail?: string
}

@InputType({ description: 'Input for updating (patching) an existing board.' })
export class BoardPatch {
  @Field({ nullable: true, description: 'The new name for the board.' })
  name?: string

  @Field({ nullable: true, description: 'The new description for the board.' })
  description?: string

  @Field({ nullable: true, description: "The new type for the board, can be 'main', 'sub', or 'popup'." })
  type?: 'main' | 'sub' | 'popup'

  @Field({ nullable: true, description: 'The new JSON model for the board.' })
  model?: string

  @Field({ nullable: true, description: 'The new group ID for the board.' })
  groupId?: string

  @Field({ nullable: true, description: 'The new base64 encoded thumbnail image for the board.' })
  thumbnail?: string
}

@ObjectType({ description: 'A paginated list of boards.' })
export class BoardList {
  @Field(type => [Board], { description: 'The list of board items.' })
  items: Board[]

  @Field(type => Int, { description: 'The total number of boards.' })
  total: number
}

@ObjectType({ description: 'A paginated list of board histories.' })
export class BoardHistoryList {
  @Field(type => [BoardHistory], { description: 'The list of board history items.' })
  items: BoardHistory[]

  @Field(type => Int, { description: 'The total number of board histories.' })
  total: number
}
